import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { fontStyleForGrapheme, graphemeDisplayText } from "#font";

export function useFontStyleForGrapheme(grapheme: string) {
  const { hanziScript } = useActorUser();
  return fontStyleForGrapheme(grapheme, hanziScript);
}

/**
 * The text to actually render for `grapheme` — see `graphemeDisplayText`. Variation sequences are
 * rewritten to the private-use code point carrying the variant glyph; all other text passes
 * through unchanged.
 */
export function useGraphemeDisplayText(grapheme: string) {
  const { hanziScript } = useActorUser();
  return graphemeDisplayText(grapheme, hanziScript);
}
